<!--
 * @Description: 
 * @Date: 2021-03-22 01:16:13
-->
<template>
  <router-view v-slot="{ Component }" class="router" :key="routeKey">
    <!-- <transition name="zoom-fade" mode="out-in" appear> -->
    <keep-alive :include="keepAliveComponents" :max="5">
      <component :is="Component" />
    </keep-alive>
    <!-- </transition> -->
  </router-view>
</template>

<script lang="ts" name="router-transition" setup>
import { ref, watch, computed } from 'vue';
import { useRoute } from 'vue-router';

const keepAliveComponents = ref<any[]>([]);
const route = useRoute();
const routeKey = computed(() => route.fullPath);

// const router = useRouter()
watch(
  () => route,
  v => {
    if (v.meta.keepAlive && keepAliveComponents.value.indexOf(v.name) === -1) {
      keepAliveComponents.value.push(v.name);
    }
  },
  { deep: true, immediate: true }
);
</script>
<style lang="scss" scoped>
.router {
  width: 100%;
  height: 100%;
  padding: 24px 16px;
}
</style>
